import { useMemo } from "react";
import { useNotifications } from "@src/packages/care/useNotifications";
import {
  isMalformedBadgeUnlockNotification,
  parseBadgeUnlockEvent,
  type BadgeUnlockEventEnvelope,
} from "./badge-events";

import { getNotificationFixtureMode } from "@src/packages/notifications/notification-fixtures";

export function useBadgeUnlockEvents() {
  const notificationsQuery = useNotifications();

  const events = useMemo(() => {
    const byEventId = new Map<string, BadgeUnlockEventEnvelope>();
    const notifications = notificationsQuery.data ?? [];

    for (const notification of notifications) {
      const envelope = parseBadgeUnlockEvent(notification);
      if (envelope && !byEventId.has(envelope.event.eventId)) {
        byEventId.set(envelope.event.eventId, envelope);
      }
    }

    return [...byEventId.values()];
  }, [notificationsQuery.data]);

  const hasMalformedEvent = useMemo(
    () =>
      (notificationsQuery.data ?? []).some(isMalformedBadgeUnlockNotification),
    [notificationsQuery.data],
  );

  return {
    ...notificationsQuery,
    events,
    hasMalformedEvent,
    isFixtureMode: getNotificationFixtureMode() !== null,
  };
}
